export default {
  en: {
    field__invoice_receipt_number: 'Invoice Receipt number',
    invoice_flow__multi_time_remainin: 'Time remaining',
    invoice_flow__multi_copy_code: 'Copy code',
    invoice_flow__multi_return_button: 'Return to web-site',
    invoice_flow__card_transfer_button: 'Confirm',

    //Steps
    invoice_flow__multi_rapipago_step_1:
      'To pay online, copy the generated code on the payment form and make the payment in the payment app.',
    invoice_flow__multi_rapipago_step_2:
      'To pay offline, save the generated barcode (voucher) or print it out and go to a Rapipago office or partner stores to pay.',
  },

  es: {
    field__invoice_receipt_number: 'Número de recibo de factura',
    invoice_flow__multi_time_remainin: 'Tiempo restante',
    invoice_flow__multi_copy_code: 'Copiar código',
    invoice_flow__multi_return_button: 'Volver al sitio web',
    invoice_flow__card_transfer_button: 'Confirmar',

    //Steps
    invoice_flow__multi_rapipago_step_1:
      'Para pagar online, copie el código generado en el formulario de pago y realice el pago en la app de pago.',
    invoice_flow__multi_rapipago_step_2:
      'Para pagar offline, guarde el código de barras generado (voucher) o imprímalo y diríjase a una oficina de Rapipago o a tiendas asociadas para pagar.',
  },
};
